import { Link } from "react-router-dom";
import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { useConsent } from "@/store/consent";
import { sp } from "@/store/nav";

const labels = {
  necessary: ["Necesarias", "Necessary"],
  functional: ["Funcionalidad", "Functional"],
  analytics: ["Analítica", "Analytics"],
  advertising: ["Publicidad", "Advertising"],
};

export default function ConsentBanner() {
  const consent = useConsent();
  const es = window.location.pathname.includes("/es/") || navigator.language?.startsWith("es");
  const [draft, setDraft] = useState(consent?.categories || {});
  if (!consent?.active || consent.decision) {
    if (!consent?.preferencesOpen) return null;
  }
  const index = es ? 0 : 1;
  const text = (esText, enText) => (es ? esText : enText);
  const toggle = (key) => setDraft((current) => ({ ...current, [key]: !current[key] }));
  return (
    <div className="fixed inset-x-0 bottom-0 z-[80] border-t border-slate-200 bg-white p-4 shadow-[0_-12px_40px_rgba(15,42,63,.18)]" data-testid="consent-banner">
      <div className="mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-start">
        <ShieldCheck className="mt-1 h-5 w-5 shrink-0 text-emerald-700" />
        <div className="min-w-0 flex-1">
          <h2 className="font-heading text-base font-bold text-slate-900" data-testid="consent-title">
            {text("Tu privacidad, tu decisión", "Your privacy, your choice")}
          </h2>
          <p className="mt-1 text-sm leading-5 text-slate-600" data-testid="consent-description">
            {text(
              "No usamos cookies ni almacenamiento de la tienda hasta que decidas. Rechazar todo permite navegar, pero impide iniciar sesión, pagar y conservar el carrito.",
              "We do not use store cookies or storage until you decide. Rejecting all lets you browse, but prevents sign-in, checkout, and saving a cart.",
            )}
          </p>
          <Link to={sp("/policies#cookies")} className="mt-2 inline-block text-xs font-semibold text-emerald-700 underline" data-testid="consent-policy-link">
            {text("Leer el aviso de cookies", "Read the cookie notice")}
          </Link>
          {consent.preferencesOpen && (
            <div className="mt-4 grid gap-2 border-t border-slate-200 pt-3 sm:grid-cols-2" data-testid="consent-preferences">
              {Object.keys(labels).map((key) => (
                <label key={key} className="flex items-start gap-2 text-sm text-slate-700" data-testid={`consent-category-${key}`}>
                  <input
                    type="checkbox"
                    checked={!!draft[key]}
                    disabled={key === "necessary"}
                    onChange={() => toggle(key)}
                    className="mt-1 accent-emerald-700"
                    data-testid={`consent-toggle-${key}`}
                  />
                  <span><b>{labels[key][index]}</b> {key === "necessary" && text("(requeridas para cuenta y compra)", "(required for account and purchase)")}</span>
                </label>
              ))}
            </div>
          )}
        </div>
        <div className="flex shrink-0 flex-wrap gap-2 sm:w-56 sm:justify-end">
          {!consent.preferencesOpen && <button type="button" onClick={consent.openPreferences} className="border border-slate-400 px-3 py-2 text-sm font-semibold text-slate-800" data-testid="consent-preferences-button">{text("Preferencias", "Preferences")}</button>}
          {consent.preferencesOpen && <button type="button" onClick={() => consent.savePreferences(draft)} className="border border-slate-400 px-3 py-2 text-sm font-semibold text-slate-800" data-testid="consent-save-button">{text("Guardar", "Save choices")}</button>}
          <button type="button" onClick={consent.rejectAll} className="border border-slate-900 px-3 py-2 text-sm font-semibold text-slate-900" data-testid="consent-reject-button">{text("Rechazar todo", "Reject all")}</button>
          <button type="button" onClick={consent.acceptAll} className="bg-[#0f2a3f] px-3 py-2 text-sm font-semibold text-white" data-testid="consent-accept-button">{text("Aceptar todo", "Accept all")}</button>
        </div>
      </div>
    </div>
  );
}